const testTypes = {
    LOFT_TEST: 'loft',
    CAT_TEST: 'cat',
};

export default testTypes;
